import { render, staticRenderFns } from "./TermsStepModule.vue?vue&type=template&id=410a5e64"
import script from "./TermsStepModule.vue?vue&type=script&lang=js"
export * from "./TermsStepModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports